// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgSortReverse24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M14.4697 9.03033C14.7626 9.32322 15.2374 9.32322 15.5303 9.03033L17.25 7.3109V16.5C17.25 16.9142 17.5858 17.25 18 17.25C18.4142 17.25 18.75 16.9142 18.75 16.5V7.3109L20.4697 9.03033C20.7359 9.2966 21.1526 9.3208 21.4462 9.10295L21.5303 9.03033C21.8232 8.73744 21.8232 8.26256 21.5303 7.96967L18.5303 4.96967C18.2374 4.67678 17.7626 4.67678 17.4697 4.96967L14.4697 7.96967C14.1768 8.26256 14.1768 8.73744 14.4697 9.03033ZM8.5 7.75C8.5 8.16421 8.16421 8.5 7.75 8.5H5C4.58579 8.5 4.25 8.16421 4.25 7.75C4.25 7.33579 4.58579 7 5 7H7.75C8.16421 7 8.5 7.33579 8.5 7.75ZM10.875 13.5C11.2892 13.5 11.625 13.1642 11.625 12.75C11.625 12.3358 11.2892 12 10.875 12H5C4.58579 12 4.25 12.3358 4.25 12.75C4.25 13.1642 4.58579 13.5 5 13.5H10.875ZM14 18.5C14.4142 18.5 14.75 18.1642 14.75 17.75C14.75 17.3358 14.4142 17 14 17H5C4.58579 17 4.25 17.3358 4.25 17.75C4.25 18.1642 4.58579 18.5 5 18.5H14Z"
				/>
			</Svg>
		);
	}
);
SvgSortReverse24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgSortReverse24;
